fragment InsuranceReimbursementFragment on insuranceReimbursement_Entry {
  typeHandle
  heading
  body
  layout
  cta {
    ...LinkFragment
  }
  backgroundBlack
  companyList {
    ... on insuranceCompanies_Entry {
      title
      companiesList {
        ... on companiesListBlock_Entry {
          companyName
          reimbursementInPercentage
          reimbursementInEur
        }
      }
    }
  }
}
